import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeleteClientSecretRequestDetails } from 'src/app/models/graph/applications/DeleteClientSecretRequestDetails';
import { GraphApplicationService } from 'src/app/services/graph/GraphApplication.service';

@Component({
  selector: 'request-details-app-delete-client-secret',
  templateUrl: './request-details-app-delete-client-secret.component.html'
})
export class RequestDetailsAppDeleteClientSecret implements OnInit {
  @Input() requestData: DeleteClientSecretRequestDetails
  @Output() doneLoading = new EventEmitter<boolean>();

  appSearchComplete: boolean = false;
  displayColumns: string[] = [ 'applicationName', 'displayName', 'endDateTime', 'clientSecretId'];

  constructor(private graphAppService: GraphApplicationService) {

  }

  async ngOnInit() {
    if (this.requestData.applicationClientSecrets.length > 0) {
      // if the Id is set, set the clientSecretId as clientSecretId is how we will be displaying it in the table
      // this is insupport of backward compatibility and we need to display it as clientSecretId to make it clear what the id is
      this.requestData.applicationClientSecrets.forEach(s => {
        if (s.id && s.id.length > 0) {
          s.clientSecretId = s.id;
        }
      });

      this.appSearchComplete = true;
      this.doneLoading.emit(true);
    }
  }
}
